<template>
  <CCard>
    <CCardHeader>
      Router Interfaces
    </CCardHeader>
    <CCardBody>
      <CRow class="mb-3">
        <CCol sm="5">
          <div class="form-group">
            <label class="form-label">Router</label>
            <SearchSelect :options="routerOptions" v-model="selectedRouter" @change="onRouterChange" />
          </div>
        </CCol>
        <CCol sm="7" class="d-flex align-items-end">
          <CButtonGroup>
            <CButton
              color="info"
              square
              @click="syncInterfaces"
              :disabled="!selectedRouter"
            >
              Sync
            </CButton>
            <CButton
              color="warning"
              square
              @click="loadUnmanaged"
              :disabled="!selectedRouter"
            >
              Claim Unmanaged
            </CButton>
          </CButtonGroup>
        </CCol>
      </CRow>
      <CDataTable
        v-if="interfaces.length"
        hover
        small
        fixed
        table-filter
        sorter
        items-per-page-select
        :items-per-page="15"
        :fields="fields"
        :items="interfaces"
        :noItemsView="{ noItems: 'No Item~' }"
        pagination
      >
        <template #status="{item}">
          <td class="py-2">
            <CBadge v-if="isTunnel(item)" color="dark">Tunnel</CBadge>
            <CBadge v-else-if="item.uuid" color="success">Managed</CBadge>
            <CBadge v-else color="warning">Unmanaged</CBadge>
          </td>
        </template>
        <template #action="{item}">
          <td class="py-2">
            <CButtonGroup>
              <CButton
                v-if="!isTunnel(item)"
                :color="item.is_dnat_port ? 'danger' : 'info'"
                square
                size="sm"
                @click="convertDNatPort(item)"
              >
                {{ item.is_dnat_port ? 'Mark Normal Port' : 'Mark DNat Port' }}
              </CButton>
              <CButton
                v-if="!isTunnel(item)"
                color="danger"
                square
                size="sm"
                @click="deleteInterface(item)"
              >
                Delete
              </CButton>
            </CButtonGroup>
          </td>
        </template>
      </CDataTable>
      <CAlert v-else-if="selectedRouter" color="secondary" fade>
        No interfaces synced yet. Click "Sync" to load from router.
      </CAlert>
    </CCardBody>
    <CToaster :autohide="3000">
      <template v-for="toast in fixedToasts">
        <CToast
          :key="'toast' + toast"
          :show="true"
          :color="alertLevel"
          header="Alert"
        >
          {{ returnMsg }}
        </CToast>
      </template>
    </CToaster>
    <CModal
      title="Message"
      color="primary"
      :show.sync="requestMsgModal"
    >
      {{ requestMsg }}
      <template #footer>
        <CButton @click="requestMsgModal=false" color="primary">Close</CButton>
      </template>
    </CModal>

    <!-- Unmanaged Interfaces -->
    <CModal
      title="Unmanaged Interfaces (实时查询)"
      color="warning"
      :show.sync="unmanagedModal"
      size="lg"
    >
      <CAlert v-if="!unmanagedList.length && !unmanagedLoading" color="success" fade>
        没有未纳管的接口（或全部为动态接口无法纳管）。
      </CAlert>
      <CDataTable
        v-if="unmanagedList.length"
        small
        fixed
        sorter
        :items-per-page="10"
        :fields="unmanagedFields"
        :items="unmanagedList"
        :noItemsView="{ noItems: 'No Item~' }"
        pagination
      >
        <template #action="{item}">
          <td class="py-2">
            <CButton
              color="success"
              square
              size="sm"
              @click="claimUnmanaged(item)"
            >
              Claim
            </CButton>
          </td>
        </template>
      </CDataTable>
      <template #footer>
        <CButton @click="unmanagedModal=false" color="primary">Close</CButton>
      </template>
    </CModal>
  </CCard>
</template>

<script>
const fields = [
  { key: "interface_name", label: "Interface" },
  { key: "type", label: "Type" },
  { key: "status", label: "Status", sorter: false, filter: false },
  {
    key: "action",
    label: "Action",
    sorter: false,
    filter: false,
    _style: "width: 28%"
  }
];

const unmanagedFields = [
  { key: "name", label: "Interface" },
  { key: "type", label: "Type" },
  { key: "comment", label: "Comment" },
  {
    key: "action",
    label: "Action",
    sorter: false,
    filter: false,
    _style: "width: 12%"
  }
];

export default {
  name: "InterfaceManagement",
  data() {
    return {
      fixedToasts: 0,
      returnMsg: "",
      alertLevel: "success",
      requestMsgModal: false,
      requestMsg: null,
      fields,
      unmanagedFields,
      routers: [],
      selectedRouter: null,
      interfaces: [],
      unmanagedModal: false,
      unmanagedList: [],
      unmanagedLoading: false
    };
  },
  computed: {
    routerOptions: function() {
      let options = [{ label: "Select a router" }];
      this.routers.map(item => {
        options.push({ value: item.id, label: item.name + "(" + item.host + ")" });
      });
      return options;
    }
  },
  mounted: function() {
    this.$axios.get("user/router", {})
      .then((response) => {
        if (response.data.code === 200) {
          this.routers = response.data.userRouter;
        }
      });
  },
  methods: {
    isTunnel: function(item) {
      return item.interface_name && item.interface_name.indexOf("-tunnel-managed-") >= 0;
    },
    onRouterChange: function() {
      this.interfaces = [];
      if (!this.selectedRouter) return;
      this.loadInterfaces();
    },
    loadInterfaces: function() {
      this.$axios.get("user/interface/list", {
        params: { router_id: this.selectedRouter }
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.interfaces = response.data.interfaces;
          }
        });
    },
    syncInterfaces: function() {
      this.$axios.get("user/router/" + this.selectedRouter + "/interfaces/sync", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.alertLevel = "success";
            this.returnMsg = "Sync success";
            this.fixedToasts++;
            this.loadInterfaces();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    claimInterface: function(item) {
      this.$axios.post("user/interface/claim", {
        router_id: this.selectedRouter,
        interface_name: item.interface_name
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.alertLevel = "success";
            this.returnMsg = response.data.msg;
            this.fixedToasts++;
            this.loadInterfaces();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    convertDNatPort: function(item) {
      this.$axios.post("user/router/interface/" + item.id + "/mark-dnat", {
        id: item.id
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.alertLevel = "success";
            this.returnMsg = response.data.msg;
            this.fixedToasts++;
            this.loadInterfaces();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    deleteInterface: function(item) {
      if (!confirm("Delete interface \"" + item.interface_name + "\" from router? This can NOT be undone.")) return;
      this.$axios.delete("user/interface/" + item.id + "/delete", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.alertLevel = "success";
            this.returnMsg = response.data.msg;
            this.fixedToasts++;
            this.loadInterfaces();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    loadUnmanaged: function() {
      this.unmanagedList = [];
      this.unmanagedLoading = true;
      this.unmanagedModal = true;
      this.$axios.get("user/interface/router/" + this.selectedRouter + "/unmanaged", {})
        .then((response) => {
          this.unmanagedLoading = false;
          if (response.data.code === 200) {
            this.unmanagedList = response.data.unmanaged;
          } else {
            this.unmanagedModal = false;
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
    claimUnmanaged: function(item) {
      this.$axios.post("user/interface/claim", {
        router_id: this.selectedRouter,
        interface_name: item.name
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.alertLevel = "success";
            this.returnMsg = response.data.msg;
            this.fixedToasts++;
            // 从弹窗列表移除
            this.unmanagedList = this.unmanagedList.filter(i => i.name !== item.name);
            this.loadInterfaces();
          } else {
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
  }
};
</script>
